import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@/services';

export const roleGuard =
  (...allowedRoles: string[]): CanActivateFn =>
  () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    return authService.hasAnyRole(allowedRoles) ? true : router.createUrlTree(['/']);
  };
